var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError500Small(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9283 62.6725L13.5283 42.8085L17.4163 40.5605L51.8163 60.4245L47.9283 62.6725Z",
    fill: "url(#paint0_linear_2903_18555)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1997 5.53623C40.9197 11.1362 48.7997 24.7362 48.7357 35.9362C48.6717 47.1362 40.7997 51.5922 31.0637 45.9842C21.3277 40.3762 13.4637 26.7842 13.5277 15.5842C13.5917 4.38423 21.4637 -0.0717742 31.1997 5.53623Z",
    fill: "url(#paint1_linear_2903_18555)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.28 3.7436C29.392 0.919598 24.96 0.655598 21.76 2.5196L18.832 4.2236C22.016 2.4636 26.4 2.7596 31.2 5.5356C40.92 11.1356 48.8 24.7356 48.736 35.9356C48.736 41.3516 46.856 45.1996 43.832 47.0876H43.776C43.52 47.2476 46.704 45.4076 46.704 45.4076C49.904 43.5676 51.816 39.6636 51.832 34.1116C51.848 22.9596 44 9.3516 34.28 3.7436Z",
    fill: "url(#paint2_linear_2903_18555)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2883 3.12812V3.41612C26.0355 3.52303 28.7062 4.35073 31.0323 5.81612C40.6323 11.3681 48.4563 24.8881 48.4243 35.9361C48.4243 43.4561 44.7763 48.1201 38.9603 48.1201C36.2128 48.0151 33.5417 47.1872 31.2163 45.7201C21.6003 40.1681 13.7923 26.6561 13.8243 15.6001C13.8243 8.08812 17.4723 3.41612 23.2883 3.41612V3.12812ZM23.2883 3.12812C17.5203 3.12812 13.5523 7.69612 13.5283 15.6001C13.5283 26.8001 21.3443 40.4001 31.0643 46.0001C33.443 47.4727 36.1645 48.2999 38.9603 48.4001C44.7283 48.4001 48.6963 43.8321 48.7203 35.9201C48.7203 24.7601 40.9043 11.1601 31.1843 5.52012C28.8075 4.04342 26.0849 3.21589 23.2883 3.12012V3.12812Z",
    fill: "url(#paint3_linear_2903_18555)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.144 39.8324C30.2669 39.3667 29.5318 38.673 29.016 37.8244C28.5967 37.0936 28.3735 36.2669 28.368 35.4244V34.6244C28.334 34.3248 28.3755 34.0215 28.4887 33.7421C28.6018 33.4626 28.7831 33.2159 29.016 33.0244C29.448 32.7444 30.16 32.8884 31.144 33.4564C32.0098 33.9195 32.732 34.6113 33.232 35.4564C33.6529 36.1865 33.8762 37.0137 33.88 37.8564V38.6564C33.9225 38.9624 33.8852 39.2743 33.7716 39.5616C33.6581 39.849 33.4722 40.1021 33.232 40.2964C32.8 40.5284 32.104 40.3924 31.144 39.8324ZM30.216 30.5284L28.8 18.2164V10.4004L33.448 13.0884V20.8724L32.136 31.6404L30.216 30.5284Z",
    fill: "url(#paint4_linear_2903_18555)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2903_18555",
    x1: 23.9683,
    y1: 36.5445,
    x2: 42.5203,
    y2: 68.6725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2903_18555",
    x1: 31.1197,
    y1: 42.0722,
    x2: 31.1197,
    y2: 2.64023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2903_18555",
    x1: 14.456,
    y1: 11.2476,
    x2: 57.312,
    y2: 35.9916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8D8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2903_18555",
    x1: 22.3523,
    y1: 40.9521,
    x2: 39.8963,
    y2: 10.5681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D0D0D0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F1F1F1",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2903_18555",
    x1: 22.928,
    y1: 21.0644,
    x2: 37.72,
    y2: 29.6004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError500Small);
export default __webpack_public_path__ + "static/media/error500Small.f602b9a5e79ddd915f8c0bb549b65a43.svg";
export { ForwardRef as ReactComponent };